import config from '../config'
import { useFetchWithAuth } from './utils'
import { Page } from './pagination/page'
import { TerminalDto, TerminalEventDto } from '../../generated-api'

const BASE = config.basePath
const BASE_CLIENT_API = `${BASE}/v1/client`

export const useGetTerminal = () => {
    const fetchWithAuth = useFetchWithAuth()
    return async (externalId: string | undefined) => {
        if (!externalId) throw Error('Terminal external ID is undefined')
        return fetchWithAuth<undefined, TerminalDto>(`${BASE_CLIENT_API}/terminals/${externalId}`)
    }
}
const getTerminalDefaultPagingParams = (pageNo: number): URLSearchParams => {
    return new URLSearchParams({
        pageNo: pageNo.toString(),
        pageSize: '50',
        total: 'false',
        sortBy: 'created',
        direction: 'DESC',
    })
}

export const useSearchTerminals = () => {
    const fetchWithAuth = useFetchWithAuth()
    return async (searchParam: string | undefined, query: string | undefined, pageNo: number) => {
        const params = getTerminalDefaultPagingParams(pageNo)

        if (searchParam) {
            params.append('searchParam', searchParam)
        }

        if (query) {
            params.append('query', query)
        }

        return fetchWithAuth<undefined, Page<TerminalDto>>(`${BASE_CLIENT_API}/terminals/search?${params}`)
    }
}

const getTerminalEventDefaultPagingParams = (pageNo: number): URLSearchParams => {
    return new URLSearchParams({
        pageNo: pageNo.toString(),
        pageSize: '10',
        total: 'false',
        sortBy: 'pspEventTimestamp',
        direction: 'DESC',
    })
}

export const useSearchTerminalEvents = () => {
    const fetchWithAuth = useFetchWithAuth()
    return async (externalId: string | undefined, pageNo: number) => {
        if (!externalId) throw Error('Terminal external ID is undefined')

        const params = getTerminalEventDefaultPagingParams(pageNo)

        return fetchWithAuth<undefined, Page<TerminalEventDto>>(
            `${BASE_CLIENT_API}/terminals/${externalId}/events/search?${params}`
        )
    }
}
